export const getShowNewSearcher = (pathname) => (
  pathname.includes('/manage') ||
  pathname.includes('/vulns/') ||
  pathname.includes('/host') ||
  pathname.includes('/knowledge_base') ||
  pathname.includes('/vulnerabilities') ||
  pathname.includes('/workspaces') ||
  pathname.includes('/services') ||
  pathname.includes('/service') ||
  pathname.includes('/legacy-report') ||
  (pathname.includes('/report') && !pathname.includes('/edit') && !pathname.includes('/new') && !pathname.includes('/report-builder')) ||
  pathname.startsWith('/templates') ||
  pathname.startsWith('/styles') ||
  pathname.includes('/automation/schedule') ||
  pathname.includes('/credentials') ||
  pathname.startsWith('/analytics') ||
  pathname.startsWith('/notifications-log') ||
  pathname.startsWith('/automation/agents')
);

export const getShowOldSearcher = (pathname) => pathname.includes('/users');

export const getShowSaveFilter = (pathname) => (
  !pathname.includes('/workspaces') &&
  !pathname.includes('/services') &&
  !pathname.includes('/service') &&
  !pathname.includes('/knowledge_base') &&
  !pathname.includes('/analytics') &&
  !pathname.includes('/templates') &&
  !pathname.includes('/styles') &&
  !pathname.includes('/report') &&
  !pathname.includes('/credentials')
);

export const getShowAdvancedMode = (pathname) => (
  !pathname.startsWith('/report') &&
  !pathname.startsWith('/analytics') &&
  !pathname.startsWith('/notifications-log') &&
  !pathname.startsWith('/templates') &&
  !pathname.startsWith('/styles') &&
  !pathname.startsWith('/legacy-report')
);
